var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKakao = function SvgKakao(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16.626c5.17 0 9.36-3.384 9.36-7.56 0-4.175-4.19-7.56-9.36-7.56-5.17 0-9.36 3.385-9.36 7.56 0 2.577 1.595 4.852 4.032 6.217l-.792 4.223 4.697-2.966c.464.057.94.086 1.423.086Z",
    fill: "current"
  })));
};
export default SvgKakao;